import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IVendorDto } from '@/dtos';


export interface Vendor {
  vendorId?: string;
  vendorName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  checkName?: string;
  checkMemo?: string;
}

const useGetVendorsQuery = () => {
  const { data, isLoading, isError } = useQuery([API_URL.VENDORS], () =>
    api.get<IVendorDto[]>(API_URL.VENDORS)
  );

  const formattedData: Vendor[] = useMemo(() => {
    if (!data?.data) {
      return [];
    }

    return data?.data?.map(
      (vendor): Vendor => ({
        vendorId: toString(vendor?.id),
        vendorName: vendor?.vendor_name,
        addressLine1: vendor?.address_line1,
        addressLine2: vendor?.address_line2,
        city: vendor?.city,
        state: vendor?.state,
        zip: vendor?.zip,
        checkName: vendor?.check_name,
        checkMemo: vendor?.check_memo,
      })
    );
  }, [data]);

  return {
    vendors: formattedData,
    isLoading,
    isError,
  };
};

export default useGetVendorsQuery;
